<template>
  <div>
    <Head title="Bookings" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Bookings</li>
      </ol>
    </nav>

    <h1>Bookings</h1>

    <div class="d-flex justify-content-between mb-3">

        <div class="input-group w-50">
          <input type="text" class="form-control" v-model="form.search">
          <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="reset">Reset</button>
        </div>


      <Link class="btn btn-primary" href="/agent-bookings/create">
        <span>Create Booking</span>
      </Link>
    </div>

    <div class="content-box">
      <table class="table">
        <thead>
          <tr>
            <th>Booking #</th>
            <th>Status</th>
            <th>Route</th>
            <th>Booking Date</th>
            <th>Customer</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="booking in bookings.data" :key="booking.id">
            <td>
              <Link :href="`/agent-bookings/${booking.id}/edit`">
                {{ booking.booking_number }}
              </Link>
            </td>
            <td>
              <Link :href="`/agent-bookings/${booking.id}/edit`">
                {{ booking.status }}
              </Link>
            </td>
            <td>
              <Link :href="`/agent-bookings/${booking.id}/edit`" v-if="booking.journeys.length">
                {{ findAirport(booking.journeys[0].departure.from).iata }} - {{ findAirport(booking.journeys[0].departure.to).iata }}
              </Link>
            </td>
            <td>
              <Link :href="`/agent-bookings/${booking.id}/edit`">
                {{ $filters.formatDate(booking.created_at) }}
              </Link>
            </td>
            <td>
              <Link :href="`/agent-bookings/${booking.id}/edit`">
                {{ booking.customers[0].first_name }} {{ booking.customers[0].middle_name }} {{ booking.customers[0].last_name }}
              </Link>
            </td>
            <td>
              <Link :href="`/agent-bookings/create/${booking.id}`">
                Duplicate
              </Link>
            </td>
          </tr>
          <tr v-if="bookings.data.length === 0">
            <td colspan="7">No bookings found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-3" :links="bookings.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    bookings: Object,
    airports: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        agencies: this.filters.agency,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/agent-bookings', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    findAirport(airportId) {
      return this.airports.filter(function(item){
          if(item.id == airportId) return item;
      })[0]
    }
  },
}
</script>
